import React from 'react';
import classes from "./style.module.scss"
import useStyles from 'isomorphic-style-loader/useStyles'
import { useHistory } from 'react-router-dom';
import { Iconfont } from '../../../../../../components/icon/iconfont';
import { useSelector } from 'react-redux';

const ListBlockItem = props => {
    useStyles(classes)
    const history = useHistory()
    const global = useSelector(state=>state.global);
    const { config } = global;

    const { item, currency, language } = props || {}

    const SOCIAL_ICONS = id => {
        switch(id){
            case 'facebook':
                return <span style={{backgroundImage:`url(https://image.geeko.ltd/chicme/20230706/f_logo_RGB-Blue_1024.svg)`}} title={id}></span>
            case 'pintrest':
                return <span style={{backgroundImage:`url(https://image.geeko.ltd/site/pc/footer-pinterest.png)`}} title={id}></span>
            case 'ins':
                return <span style={{backgroundImage:`url(https://image.geeko.ltd/chicme/20230713085047934573.png)`}} title={id}></span>
            case 'tiktok':
                return <span style={{backgroundImage:`url(https://image.geeko.ltd/site/pc/footer-tiktok.png)`}} title={id}></span>
            case 'youtube':
                return <span style={{backgroundImage:`url(https://image.geeko.ltd/site/pc/footer-youtube.png)`,marginBottom:"-5px"}} title={id}></span>
            default:
                return ''
        }
    }

    const Social = props => {
        useStyles(classes)
        const {social} = props
        return <a className={`${classes.Social}`} href={social.url} title={social.id}>
            {SOCIAL_ICONS(social.id)}
        </a>
    }

    return <div className={classes.ListBlockItem} 
                onClick={() => {
                    if(item?.showLan){
                        props?.showLanguage()
                    } else if(item?.showCurrency){
                        props?.showCurrency()
                    } else if(item?.outer){
                        window.location.href = item?.href
                    } else if(item?.href){
                        history?.push(item?.href)
                        // window.location.href = item?.href
                    }
                }}>
        <div className={classes.ItemLabel} style={{textTransform:item?.type=='follow_us' ?'capitalize':'unset'}}>
            {item?.name}
        </div>
        <div className={classes.ItemLink}>
            {
                (item?.showLan || item?.showCurrency) &&
                <span>{item?.showLan ? language : currency}</span>
            }
            {
                item?.type == 'follow_us'?
                <React.Fragment>
                    {/* 显示 fb 和 ins 的图标，点击去社媒主页 */}
                    {
                        config?.socials?.filter(c => c.id == 'facebook' || c.id == 'ins')?.length > 0 &&
                        <div className={classes.SocialsList}>
                            {
                                config?.socials?.filter(c => c.id == 'facebook' || c.id == 'ins').map(social => <Social key={social.id} social={social}/>)
                            }
                        </div>
                    }
                </React.Fragment>:
                <Iconfont className={classes.LinkIcon}>&#xe694;</Iconfont>
            }
        </div>
    </div>
}

const ListBlock = props => {
    useStyles(classes)

    const { data } = props || {}

    return <div className={classes.ListBlock}>
        {
            data?.map((item) => {
                return <ListBlockItem key={item?.id} item={item} {...props} ></ListBlockItem>
            })
        }
    </div>
}

const SettingList = props => {
    useStyles(classes)
    const { list } = props || {}

    return <div className={classes.SettingList}>
        {
            list?.map((item) => {
                return <ListBlock key={item?.id} data={item?.children} {...props}></ListBlock>
            })
        }
    </div>
}

export default SettingList